var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":_vm.size,"type":"success"},on:{"click":_vm.handleClick}},[_vm._v("\n    复制单据\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }